import React, { Component, Fragment } from "react";
import { Button, Container, Image } from "react-bootstrap";
import { Page } from "react-pdf";
import { Document } from "react-pdf";
import { connect } from "react-redux";

import CustomButton from "../../../components/UI/Button/Button";
import Modal from "../../../components/UI/Modal/Modal";
import dynamicMessages from "../../../dynamicMessages";
import * as actions from "../../../store/actions/index.js";
import DisputeAuthorization from "../DisputeAuthorization/DisputeAuthorization";
import BrowseImages from "./BrowseImages/BrowseImages";
import classes from "./UploadBills.module.css";
import ViewingBills from "./ViewingBills/ViewingBills";

import dollar from "../../../assets/images/icon-dollar-small.svg";

interface IParentProps {
  goBackHandler: () => void;
}
interface IStateFromProps {
  providerBills: File[];
  documentTypes: {
    id: string;
    type: string;
    editable: boolean;
    order: number;
  }[];
  config_values: {
    customValue: string | null;
    defaultValue: string;
    element: string;
    elementType: string;
    id: string;
    targetPageTitle: string;
  }[];
  balanceBillView: string;
  // t:any;
  t: any;
  i18n: any;
}
interface IDispatchFromProps {
  onRemoveProviderBills: (fileArray: File[]) => void;
  onSetBalanceBillViewState: (balanceBillView) => void;
}
type Props = IStateFromProps & IDispatchFromProps & IParentProps;
class UploadBills extends Component<Props> {
  state = {
    billsUploading: false,
    billsUploaded: false,
    providerBillsAvailable: true,
    providerBillsNotAvailable: false,
    viewingBills: false,
    viewBillNumber: 0,
    disputeAuthorizationForm: false,
    addressAlertShow: true,
  };
  componentDidUpdate(prevProps, prevState) {
    if (this.props.providerBills.length !== prevProps.providerBills.length) {
      if (this.props.providerBills.length > 0) {
        this.setState({ billsUploaded: true });
      } else {
        this.setState({ billsUploaded: false });
      }
    }
    if (prevProps.balanceBillView !== this.props.balanceBillView) {
      console.log("inside if of getStarted");
      if (this.props.balanceBillView === "disputeAuthorizationForm") {
        this.setState({ disputeAuthorizationForm: true });
      } else if (
        this.props.balanceBillView === "notDisputeAuthorizationForm" ||
        this.props.balanceBillView === ""
      ) {
        this.setState({ disputeAuthorizationForm: false });
      }
    }
  }
  // componentWillUnmount() {
  //   this.props.onRemoveProviderBills([]);
  // }
  uploadReceiptsHandler = () => {
    this.setState({ billsUploading: true });
  };
  billsUploadHandler = () => {
    this.setState({ billsUploading: false });
  };

  deleteHandler = (index: number) => {
    var array = [...this.props.providerBills];
    if (index !== -1) {
      array.splice(index, 1);
      this.props.onRemoveProviderBills(array);
    }
  };
  onChangeFavorite = (event) => {
    console.log(event.target.checked, event.target.name);
    if (event.target.checked) {
      this.setState({ providerBillsAvailable: false });
      this.setState({ providerBillsNotAvailable: true });
    } else if (!event.target.checked) {
      this.setState({ providerBillsAvailable: true });
      this.setState({ providerBillsNotAvailable: false });
    }
  };
  viewingBillsHandler = (index: number) => {
    console.log(index);
    this.setState({ viewBillNumber: index });
    this.setState({ viewingBills: true });
  };
  closeViewingBillsHandler = () => {
    this.setState({ viewingBills: false });
  };
  disputeAuthorizationFormHandler = () => {
    this.setState({ disputeAuthorizationForm: true });
    this.props.onSetBalanceBillViewState("disputeAuthorizationForm");
  };
  disputeAuthorizationFormBackHandler = () => {
    this.setState({ disputeAuthorizationForm: false });
    this.props.onSetBalanceBillViewState("notDisputeAuthorizationForm");
  };
  goBackHandler = () => {
    this.props.onRemoveProviderBills([]);
    this.props.goBackHandler();
  };
  closeAddressAlert = () => {
    this.setState({ addressAlertShow: false });
  };
  render() {
    const { t, i18n } = this.props;
    // const { goBackHandler } = { ...this.props };
    const nextBtnStyle = {
      minWidth: "150px",
    };
    const modalViewBillStyle = {
      width: "400px",
      left: "calc(50% - 200px)",
      top: "15%",
      position: "absolute",
    };
    const billsUpload = (
      <Modal
        show={this.state.billsUploading}
        childComp={<BrowseImages modalClosed={this.billsUploadHandler} />}
        style={{}}
      />
    );

    let viewBills: any;
    if (this.state.viewingBills) {
      viewBills = (
        <Modal
          show={this.state.viewingBills}
          childComp={
            <ViewingBills
              viewBillNumber={this.state.viewBillNumber}
              closeViewing={this.closeViewingBillsHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }

    let providerBills: any;
    if (this.state.providerBillsAvailable) {
      providerBills = (
        <div>
          <div className={classes.vl}></div>
          <div className="uploadList">
            {this.props.config_values &&
            this.props.config_values.find(
              (ele) =>
                ele.targetPageTitle.toLowerCase() ===
                  "1st Balance Bill".toLowerCase() &&
                ele.element.toLowerCase() === "Before you Upload".toLowerCase()
            )
              ? this.props.config_values.find(
                  (ele) =>
                    ele.targetPageTitle.toLowerCase() ===
                      "1st Balance Bill".toLowerCase() &&
                    ele.element.toLowerCase() ===
                      "Before you Upload".toLowerCase()
                )?.customValue
                ? this.props.config_values
                    .find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "1st Balance Bill".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Before you Upload".toLowerCase()
                    )
                    ?.customValue?.split("\n")
                    .map((item, key) => {
                      return (
                        <span key={key}>
                          {item}
                          <br />
                        </span>
                      );
                    })
                : this.props.config_values
                    .find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "1st Balance Bill".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Before you Upload".toLowerCase()
                    )
                    ?.defaultValue?.split("\n")
                    .map((item, key) => {
                      return (
                        <span key={key}>
                          {dynamicMessages(item)
                            ? t(dynamicMessages(item))
                            : item}
                          <br />
                        </span>
                      );
                    })
              : ``}
          </div>
        </div>
      );
    } else if (this.state.providerBillsNotAvailable) {
      providerBills = (
        <div className={classes.vl}>
          <div className="uploadList">
            <strong>{t("providerBills.pleaseNote")}</strong>
            <ul>
              <li>{t("providerBills.first")}</li>
              <li>{t("providerBills.second")}</li>
            </ul>
          </div>
        </div>
      );
    }

    let preview: any;
    if (this.props.providerBills && this.props.providerBills.length > 0) {
      preview = (
        <div className="uploadPreviews">
          {(this.props.providerBills || []).map((url, index) => (
            <div className="uploadPreview" key={`file${index}`}>
              <div className="previewThumb">
                {console.log("url is ", url.name)}
                {url.name.includes("pdf") ? (
                  <Document file={url}>
                    <Page
                      pageNumber={1}
                      onClick={() => this.viewingBillsHandler(index)}
                    />
                  </Document>
                ) : (
                  <img
                    src={URL.createObjectURL(url)}
                    alt="..."
                    onClick={() => this.viewingBillsHandler(index)}
                  />
                )}
              </div>
              <span
                className="closeBtn"
                onClick={() => this.deleteHandler(index)}
              >
                <span>x</span>
              </span>
            </div>
          ))}
        </div>
      );
    }
    let billsUploadedCount: any;
    billsUploadedCount = (
      <div className="selectedFiles">
        <div>
          <span className="filesCount">
            {this.props.providerBills ? this.props.providerBills.length : "0"}{" "}
          </span>{" "}
          {t("uploadBill.billsUploaded")}
        </div>
      </div>
    );

    let disputeAuthorizationForm: any;
    if (this.state.disputeAuthorizationForm) {
      disputeAuthorizationForm = (
        <DisputeAuthorization
          t={t}
          i18n={i18n}
          goBackHandler={this.disputeAuthorizationFormBackHandler}
        />
      );
    } else
      disputeAuthorizationForm = (
        <Fragment>
          <Container fluid>
            {billsUpload}
            {viewBills}
            {/* {addressAlert} */}
            <div className="inner-banner">
              <div className="inner-banner-title">
                <h3>{t("uploadBill.balanceBilling")}</h3>
                <Image
                  src={dollar}
                  alt="stock-image"
                  className={classes.stockimage}
                  data-test="stockIMG"
                />
              </div>
            </div>
            <div className="mainContainer">
              <div className="text-center">
                <h6 className="bill-heading">{t("uploadBill.newUpload")}</h6>
                <div className="step-circles">
                  <ul>
                    <li className="active"></li>
                    <li className="select"></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                  </ul>
                </div>
                <div className="bb-text">
                  <strong>
                    {this.props.documentTypes.length > 0 &&
                      this.props.documentTypes.find(
                        (title) => title.order === 1
                      )?.type}
                  </strong>
                  <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle === "1st Balance Bill" &&
                        ele.element.toLowerCase() === "header"
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle === "1st Balance Bill" &&
                            ele.element.toLowerCase() === "header"
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle === "1st Balance Bill" &&
                                ele.element.toLowerCase() === "header"
                            )
                            ?.customValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle === "1st Balance Bill" &&
                                ele.element.toLowerCase() === "header"
                            )
                            ?.defaultValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item ===
                                  "Have you received your detailed billing statement from your Provider?"
                                    ? t("uploadBill.textContent")
                                    : item}
                                  <br />
                                </span>
                              );
                            })
                      : t("uploadBill.textContent")}
                  </p>
                </div>
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="customSwitches"
                    onChange={this.onChangeFavorite}
                  />
                  <span className="switchUnChecked">{t("uploadBill.yes")}</span>
                  <label
                    className="custom-control-label"
                    htmlFor="customSwitches"
                  ></label>
                  <span className="switchChecked">{t("uploadBill.no")}</span>
                </div>
              </div>
              {this.state.billsUploaded && billsUploadedCount}
              {!this.state.billsUploaded && providerBills}
              {preview}
              <div className="text-center">
                <Button
                  className="btn-lg-border"
                  onClick={this.uploadReceiptsHandler}
                  disabled={this.state.providerBillsAvailable ? false : true}
                >
                  <span>
                    {this.state.billsUploaded
                      ? t("submitBill.addMore")
                      : `${t("uploadFile.uploadBtn")} ${
                          this.props.documentTypes.length > 0 &&
                          this.props.documentTypes.find(
                            (title) => title.order === 1
                          )?.type
                        }`}
                  </span>
                  <i>+</i>
                </Button>
              </div>

              <div className="flexButtons">
                <CustomButton
                  label={t("uploadBill.back")}
                  clicked={this.goBackHandler}
                  style={nextBtnStyle}
                  displayImg={false}
                  image=""
                  disabled={false}
                />
                <CustomButton
                  label={t("uploadBill.next")}
                  clicked={this.disputeAuthorizationFormHandler}
                  style={nextBtnStyle}
                  displayImg={false}
                  image=""
                  disabled={
                    this.state.billsUploaded &&
                    this.state.providerBillsAvailable
                      ? false
                      : true
                  }
                />
              </div>
            </div>
          </Container>
        </Fragment>
      );
    return <Fragment>{disputeAuthorizationForm}</Fragment>;
  }
}
const mapStateToProps = (state: any) => ({
  providerBills: state.browseImages.providerBills,
  documentTypes: state.fetchDocumentTypes.documentTypes,
  config_values: state.appConfig.config_values,
  balanceBillView: state.setBalanceBillViewState.balanceBillView,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onRemoveProviderBills: (providerBills) =>
    dispatch(actions.providerBills(providerBills)),
  onSetBalanceBillViewState: (balanceBillView) =>
    dispatch(actions.setBalanceBillViewState(balanceBillView)),
});
export default connect(mapStateToProps, mapDispatchToProps)(UploadBills);
// export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UploadBills));
